import {List, Map} from 'immutable';

/**
 * Given a list, keyFn and an optional map to associate into
 * returns an immutable Map with each of the elements of the list
 * set into the map with a key generated via the given keyFn
 *
 * @param list A list of elements to associate.
 * @param keyFn A function which given an element of the list, returns a key
 * (e.g., plan => plan.id).
 * @param accumulator The map to associate the list with.
 *
 * @returns map associating values with the keys returned by keyFn.
 */
export function associateBy<Element, Key>(
  list: List<Element> | Element[],
  keyFn: (e: Element) => Key,
  accumulator = Map() as Map<Key, Element>
): Map<Key, Element> {
  return list.reduce((acc, val) => acc.set(keyFn(val), val), accumulator);
}
